// getters
const restaurantEnlistment = state => state.enlistment

export default {
  restaurantEnlistment
}



// WEBPACK FOOTER //
// ./src/store/modules/restaurant/enlistment/getters.js